import { createSelector } from '@reduxjs/toolkit';
export const progressionStatusReducer = (state) => state.progressionStatus;
export const progressionStatusSelector = createSelector(progressionStatusReducer, (reducer) => reducer.resources);
